import { RouteConfig } from "vue-router";

export const RCandidateTasksTemplate: RouteConfig = {
  path: ":taskId(\\d+)",
  name: "CandidateTasksTemplate",
  component: () =>
    import(
      /* webpackChunkName: "candidate-tasks-template" */
      "./VCandidateTasksTemplate.vue"
    ),
  meta: {
    backLink: "/cases/tasks",
    hide: true,
    version: 2,
  },
};
